export class UsuarioFormulario {
	// Alimentar los inputs
	Id: string;
	Nombre: string;
	Login: string;
	Contrasenia: string;
	Email: string;

	FechaAlta: string;
	FechaBaja: string;
	Tipo: string; // Tipo de Perfil
	NombreTipo: string;
	Activo: boolean;

	// Objeto de Breeze
	PERFIL: any;
	ENTIDAD: any;

	constructor(usuario?) {
		this.Id = '';
		this.Nombre = '';
		this.Login = '';
		this.Contrasenia = '';
		this.ENTIDAD = {};
		this.PERFIL = {};
		this.Tipo = '';
		this.NombreTipo = '';

		if (usuario) {

			this.ENTIDAD = usuario;
			this.PERFIL = usuario.PERFIL;
			this.Id = usuario.Id;
			this.Nombre = usuario.Nombre;
			this.Login = usuario.Login;
			this.Email = usuario.Email;
			this.Contrasenia = usuario.Contrasenia;
			this.FechaAlta = usuario.FechaAlta;
			this.FechaBaja = usuario.FechaBaja;

			const now = new Date();
			if (usuario.FechaBaja !== undefined && usuario.FechaBaja !== null) {

				if ( now.getTime() > usuario.FechaBaja.getTime()) {
					this.Activo = false;
				}
				else{
					this.Activo = true;
				}

			}
			else{
				this.Activo = true;
			}

			if (usuario.PERFIL) {
				this.Tipo = usuario.PERFIL.Tipo;
				this.NombreTipo = usuario.PERFIL.Nombre;
			}
		}
	}
}




// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/UsuarioFormulario.ts